const SynchronizeLayout = () => import(/* webpackChunkName: "synchronize" */'@/components/synchronize/SynchronizeLayout')
const SyncEmployeeList = () => import(/* webpackChunkName: "synchronize" */'@/components/synchronize/SyncEmployeeList')
const SyncEmployeeEdit = () => import(/* webpackChunkName: "synchronize" */'@/components/synchronize/SyncEmployeeEdit')
const CvpSync = () => import(/* webpackChunkName: "synchronize" */'@/components/synchronize/CvpSync')

export default {
  path: 'synchronize',
  component: SynchronizeLayout,
  children: [{
    name: 'syncEmployeeList',
    path: 'syncEmployeeList',
    component: SyncEmployeeList,
    meta: {
      module: 'synchronize',
      keepAlive: true,
    },
  }, {
    name: 'syncEmployeeEdit',
    path: 'syncEmployeeList/syncEmployeeEdit',
    component: SyncEmployeeEdit,
    meta: {
      module: 'synchronize',
    },
  }, {
    name: 'cvpSync',
    path: 'cvpSync',
    component: CvpSync,
    meta: {
      module: 'synchronize',
    },
  }, {
    path: '/',
    redirect: {name: 'syncEmployeeList'},
  }],
}



// WEBPACK FOOTER //
// ./src/router/synchronize.js